import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
    isFirstBrower:false,
    loginIp:"",
    Province:"",
    Region:"",
    browerPageList:[]
}
const getters = {
    getisFirstBrower(state,path){
      console.log(path)
      return state.browerPageList.includes(path);
    }
}
const mutations = {
  // 设置浏览
  setBrower(state,path=""){
      if(path!=""){
        state.browerPageList.push(path);
      }
  },
  // 设置浏览人信息
  setBrowerInfo(loginIp,Province,Region){
    state.loginIp = loginIp
    state.Province = Province
    state.Region = Region
  }
}

const actions = {
  commitFirstBrower({commit},path){
    commit("setBrower",path);
  },
  commitBrowerInfo({commit},loginIp,Province,Region){
    commit("setBrowerInfo");
  }
}
const store = new Vuex.Store({
  state,
  mutations,
  getters,
  actions
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js